import Color from '../Color.js';
import mix from '../generator/mix.js';

Color.prototype.mix = Color.prototype.interpolate = function (
    col2,
    f = 0.5,
    ...rest
) {
    return mix(this, col2, f, ...rest);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/ops/mix.js
// module id = 2524
// module chunks = 6